import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=d5c1ace4&scoped=true&"
var script = {}
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=d5c1ace4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c1ace4",
  null
  
)

export default component.exports